import { Employment } from '../../models/employment';
import { PoolerEmploymentTabIdEnum } from '../../models/PoolerEmploymentTabIdEnum';
import { PoolerUser } from '../../models/user';
import { getEmploymentRangeQuery } from './getEmploymentRangeQuery';
import { getEmploymentSearchQuery } from './getEmploymentSearchQuery';
import { getPoolerEmploymentsTabQuery } from './getPoolerTabQuery';

export function getPoolerEmploymentsQuery(
  tabId: PoolerEmploymentTabIdEnum,
  search: string | undefined,
  range: string | undefined,
  currentUser: PoolerUser,
): Mongo.Selector<Employment> {
  const $and: Mongo.Selector<Employment>[] = [
    getPoolerEmploymentsTabQuery(tabId, currentUser),
  ];
  if (search) {
    $and.push(getEmploymentSearchQuery(search));
  }
  if (range) {
    $and.push(getEmploymentRangeQuery(range));
  }
  return {
    $and,
  };
}
